import { type ReactNode, useState } from 'react'

import { HorizontalChipStrip } from '../HorizontalChipStrip'

type Props = {
  className?: string
  trackClassName?: string
  children: (stripScrollRoot: HTMLDivElement | null) => ReactNode
}

/**
 * 时间线横滑：暴露 strip DOM，供子图以该滚动容器为 IntersectionObserver root 懒加载。
 */
export function TimelineRoundStrip({ className, trackClassName, children }: Props) {
  const [stripEl, setStripEl] = useState<HTMLDivElement | null>(null)
  return (
    <HorizontalChipStrip ref={setStripEl} className={className} trackClassName={trackClassName}>
      {children(stripEl)}
    </HorizontalChipStrip>
  )
}
